/**
 * The Functions page a member last had open, remembered on this device so
 * the tab opens on it again: a per-viewer convenience, so localStorage, and
 * a page that cannot read it opens on the first page instead.
 */
const KEY = 'relay:last-function';

export function lastFunction(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function rememberFunction(id: string): void {
  try {
    window.localStorage.setItem(KEY, id);
  } catch {
    // Not remembered; the tab opens on its first page, which is harmless.
  }
}
